import { connect } from 'react-redux';

import CognitoFormsAdminListTabs from '../components/CognitoFormsAdminListTabs';
import storage from '../../../../../lib/Storage';
import {
  loadCognitoFormsAdmin,
  deleteCognitoFormAdmin,
  patchCognitoFormAdmin,
  cognitoFormAdminShowForm,
} from '../../../../../state/modules/cognitoFormsAdmin/actions';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  return {
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, page, limit, order, filter, cb) => {
      dispatch(
        loadCognitoFormsAdmin(partnershipId, page, limit, order, filter, cb)
      );
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteCognitoFormAdmin(partnershipId, id, cb));
    },
    patch: (partnershipId, id, payload, cb) => {
      dispatch(patchCognitoFormAdmin(partnershipId, id, payload, cb));
    },
    showForm: (id) => {
      dispatch(cognitoFormAdminShowForm(id));
    },
  };
};

const CognitoFormsAdminListTabsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormsAdminListTabs);

export default CognitoFormsAdminListTabsContainer;
